import { Nullable } from '@homeserve/od-typings/utils';
import { Validator } from 'vee-validate';

// Regex from https://gitlab.com/ondemandhsv/vue-components-plugin/blob/develop/src/components/WLTunnel/Components/WLPassword.vue
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

export default function isValidPassword(value: Nullable<string>): boolean {
  if (!value) {
    return false;
  }

  return passwordRegex.test(value);
}

Validator.extend('password', isValidPassword);
